<!--
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2024-12-24 18:04:01
 * @Description: 时间选择组件
-->
<template>
  <div>
    <RangePicker style="width: 100%;" :value="hackValue || text" :format="props.item.format || 'YYYY-MM-DD HH:mm:ss'"
      :value-format="props.item.format || 'YYYY-MM-DD HH:mm:ss'" :show-time="{
        defaultValue: props.item.defaultValue || [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
      }" v-bind="props.item.attrs || {}" @change="onChange" @openChange="onOpenChange" @calendarChange="onCalendarChange" :disabled-date="props.item.disabledDate || disabledDate">
    </RangePicker>
  </div>
</template>

<script setup lang='ts'>
import {
  message,
  RangePicker
} from 'ant-design-vue'
import { FormListItem } from '@xinghai/site-common';
import { PropType, ref, computed } from 'vue'
import dayjs, { Dayjs } from 'dayjs';
import { lang } from '@/utils';
type RangeValue = [any, any] | [Dayjs, Dayjs];
const emits = defineEmits(['update:value'])
const props = defineProps({
  item: { type: Object as PropType<Partial<FormListItem>>, default: {} as Partial<FormListItem> },
  searchParam: { type: Object, default: {} as Record<string, any> },
  value: {
    type: Array,
    required: true
  }
})
const text = computed({
  get() {
    return props.value as any;
  },
  set(newValue) {
    emits('update:value', newValue);
  }
})
const dates = ref<RangeValue>();
const hackValue = ref<RangeValue>();
const disabledDate = (current: Dayjs) => {
  const flag = (current && current > dayjs().endOf('day')) || (current && current < dayjs().subtract(props.item.limitDay || 180, 'day'))
  if (!dates.value || (dates.value as any).length === 0) {
    return flag
  }
  if (props.item.maxDate) {
    const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > props.item.maxDate - 1 || flag;
    const tooEarly = dates.value[1] && (dayjs(dates.value[1]).diff(current, 'days') > props.item.maxDate || flag);
    return tooEarly || tooLate;
  }
  return flag;
};

const onOpenChange = (open: boolean) => {
  if (open) {
    dates.value = [] as any;
    hackValue.value = [] as any;
  } else {
    hackValue.value = undefined;
  }
};

const onChange = (val: RangeValue) => {
  if (props.item.maxDate && val) {
    const [start, end] = val.map((date: any) => dayjs(date));
    const diff = end.diff(start, 'days'); // 计算天数差
    if (diff > props.item.maxDate) {
      message.warning(lang(`日期范围不能超过${props.item.maxDate}天！`))
      return
    }
  }
  text.value = val;
  if (props.item.realField) {
    props.item.realField.forEach((_, i) => {
      props.searchParam[_] = val ? val[i] : ''
    })
  }
};

const onCalendarChange = (val: RangeValue) => {
  dates.value = val;
}

</script>
<style scoped lang='scss'></style>